/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const ReadMessageIcon = ({
  className,
  style,
  color = '#3952FA',
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      style={style}
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7731 0.164958C13.0501 0.407413 13.0782 0.828588 12.8358 1.10568L7.73065 6.9401C7.611 7.07684 7.44074 7.15882 7.25924 7.16708C7.07774 7.17534 6.90073 7.10916 6.76916 6.98386L5.36372 5.64535L4.23146 6.93937C4.11182 7.0761 3.94155 7.15808 3.76005 7.16634C3.57855 7.1746 3.40154 7.10843 3.26997 6.98312L0.206898 4.06591C-0.0597224 3.81199 -0.0700147 3.39 0.183909 3.12338C0.437833 2.85676 0.859818 2.84647 1.12644 3.10039L3.68595 5.53802L4.39735 4.72499L3.70609 4.06665C3.43947 3.81272 3.42917 3.39074 3.6831 3.12412C3.93702 2.8575 4.35901 2.84721 4.62563 3.10113L7.18513 5.53876L11.8323 0.227673C12.0748 -0.0494184 12.496 -0.0774967 12.7731 0.164958ZM9.33621 1.10568C9.57866 0.828588 9.55058 0.407413 9.27349 0.164958C8.9964 -0.0774967 8.57523 -0.0494184 8.33277 0.227673L6.29072 2.56144C6.04827 2.83853 6.07635 3.25971 6.35344 3.50216C6.63053 3.74462 7.0517 3.71654 7.29416 3.43945L9.33621 1.10568Z"
        fill={color}
      />
    </svg>
  );
};
